import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DocumentEntity, DocumentTypeEnum, ResponseApiDto } from '@domain';
import { environment } from '@environments';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocumentCreateApi {
    private prefix = 'document/create';
    private _httpClient = inject(HttpClient);

    /**
     * Cria um novo documento
     * @param orderId ID do serviço
     * @param type Tipo de documento
     * @returns Observable<ResponseApiDto<DocumentEntity>>
     */
    public insert(
        orderId: string,
        type: DocumentTypeEnum
    ): Observable<ResponseApiDto<DocumentEntity>> {
        try {
            const url = `${environment.API_BASE}${this.prefix}`;
            const body = { orderId, type };

            return this._httpClient.post<ResponseApiDto<DocumentEntity>>(url, body);
        } catch (error) {
            throw error;
        }
    }

    /**
     * Cria um documento AVULSO (sem serviço/cliente): o backend cria a "order
     * pessoal" invisível que o contém. Só NORMAL/RESUME — QUOTE/CONTRATO são
     * bloqueados pelo backend (precisam de cliente).
     * @param type Tipo do documento
     * @returns Observable<ResponseApiDto<DocumentEntity>>
     */
    public insertStandalone(
        type: DocumentTypeEnum = DocumentTypeEnum.NORMAL
    ): Observable<ResponseApiDto<DocumentEntity>> {
        const url = `${environment.API_BASE}${this.prefix}/standalone`;

        return this._httpClient.post<ResponseApiDto<DocumentEntity>>(url, { type });
    }

    /**
     * Cria um novo documento
     * @param orderId ID do serviço (`null`: documento avulso)
     * @param templateId ID do template
     * @returns Observable<ResponseApiDto<DocumentEntity>>
     */
    public insertByTemplate(
        orderId: string | null,
        templateId: string
    ): Observable<ResponseApiDto<DocumentEntity>> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/by-template`;
            // Sem `orderId` o documento nasce AVULSO (order pessoal criada pela API).
            const body = orderId ? { orderId, templateId } : { templateId };

            return this._httpClient.post<ResponseApiDto<DocumentEntity>>(url, body);
        } catch (error) {
            throw error;
        }
    }

    /**
     * Cria um novo documento
     * @param orderId ID do serviço (`null`: documento avulso)
     * @param internalTemplateId ID do template interno
     * @returns Observable<ResponseApiDto<DocumentEntity>>
     */
    public insertByInternalTemplate(
        orderId: string | null,
        internalTemplateId: string
    ): Observable<ResponseApiDto<DocumentEntity>> {
        try {
            const url = `${environment.API_BASE}${this.prefix}/by-internal-template`;
            // Sem `orderId` o documento nasce AVULSO (order pessoal criada pela API).
            const body = orderId ? { orderId, internalTemplateId } : { internalTemplateId };

            return this._httpClient.post<ResponseApiDto<DocumentEntity>>(url, body);
        } catch (error) {
            throw error;
        }
    }
}
